 export const LoginRequest={
    username :"",
    password:"",
    captcha:""
}